// extracted by mini-css-extract-plugin
export default {"task":"TaskList_task__Pt-Tt","info":"TaskList_info__r8QX0","actions":"TaskList_actions__jMoGE"};